import { Reveal, Eyebrow } from "./Reveal";
import { PRINCIPLES } from "../../data/site";

export default function Manifesto() {
    return (
        <section data-testid="manifesto-section" className="grain relative border-t border-slate-200 bg-blue-50/50 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal>
                    <Eyebrow testId="manifesto-eyebrow">Why Apan Code Labs</Eyebrow>
                    <h2 className="max-w-4xl font-display text-3xl font-bold leading-[1.15] tracking-tight text-balance text-slate-900 sm:text-5xl">
                        Technology is only useful when it solves the{" "}
                        <span className="text-brand">right problem</span>.
                    </h2>
                </Reveal>

                <div className="mt-20">
                    {PRINCIPLES.map((p, i) => (
                        <Reveal key={p.num} delay={i * 0.06}>
                            <div
                                data-testid={`principle-${p.num}`}
                                className="group grid grid-cols-1 gap-3 border-t border-brand/15 py-10 transition-colors duration-500 last:border-b hover:bg-white/70 sm:grid-cols-12 sm:items-baseline sm:gap-8 sm:py-12"
                            >
                                <span className="font-mono text-sm font-semibold tracking-[0.25em] text-brand sm:col-span-2">
                                    {p.num}
                                </span>
                                <h3 className="font-display text-2xl font-semibold tracking-tight text-slate-900 transition-transform duration-500 group-hover:translate-x-2 sm:col-span-4 sm:text-3xl">
                                    {p.title}
                                </h3>
                                <p className="text-base leading-relaxed text-slate-600 sm:col-span-6 sm:text-lg">
                                    {p.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
